module.exports = require('./kmeans');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-kmeans/src/index.js
 ** module id = 130
 ** module chunks = 0
 **/